import { getSearchFlightTotalPrice } from "@/entities/flight"
import type { ISearchFlight } from "@/shared/api/aviabooking"

/** Search pricing stays independent of the stricter saved-flight snapshot validation. */
export function filterFlightsByPrice(flights: ISearchFlight[], min: number | null, max: number | null) {
    return flights.filter(flight => {
        const price = getSearchFlightTotalPrice(flight)
        return (min === null || price >= min) && (max === null || price <= max)
    })
}
